export const SENTRY_DSN_URL =
  'https://091e9dcfb15e766a09b067aa601d7441@o1100855.ingest.sentry.io/4506111278579712'

export const POSTHOG_KEY = 'phc_KEFUBXT5v69uHr9qN3tBSOEXkJ4t2KJ1PAZlFgnErho'

export const POSTHOG_API_HOST = 'https://eu.posthog.com'
